import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@styles/tokens.css'
import '@styles/tokens-v3.css'
import '@styles/tokens-mode.css'
import '@styles/reset.css'
import '@styles/typography.css'
import '@styles/global.css'
import '@styles/ui-primitives.css'
import '@styles/v3-pages-bundle.css'
import '@styles/polish-v3.css'
import '@styles/typography-v3-product.css'
import '@styles/theme-dark-v3.css'
import { App } from './App.js'
import { AppErrorBoundary } from '@components/AppErrorBoundary.js'
import { UpdatePrompt } from '@components/layout/UpdatePrompt.js'
import { useThemeStore } from '@stores/themeStore.js'
import { syncAppVersion } from '@services/appStorage.js'

useThemeStore.getState().init()
syncAppVersion()

/** SW em dev costuma cachear bundle antigo e travar preview no celular. */
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const reg of regs) void reg.unregister()
  })
}

const root = document.getElementById('app')
if (!root) {
  document.body.innerHTML =
    '<p style="padding:1rem;font-family:DM Sans Variable,DM Sans,system-ui,sans-serif">Erro: elemento #app não encontrado.</p>'
} else {
  createRoot(root).render(
    <StrictMode>
      <AppErrorBoundary>
        <App />
        <UpdatePrompt />
      </AppErrorBoundary>
    </StrictMode>,
  )
}
